import { render } from "./BillsComponent.vue?vue&type=template&id=7edcbb6c&scoped=true"
import script from "./BillsComponent.vue?vue&type=script&lang=js"
export * from "./BillsComponent.vue?vue&type=script&lang=js"

import "./BillsComponent.vue?vue&type=style&index=0&id=7edcbb6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edcbb6c"]])

export default __exports__